import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0052FF" />
    <path d="M16 19h32" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" />
    <path d="M32 19v9" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" />
    <path d="M23 44l8-8 6 4 10-11" fill="none" stroke="#FFFFFF" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M41 28h7v7" fill="none" stroke="#FFFFFF" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="23" cy="44" r="3" fill="#FFFFFF" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <Link to="/" data-testid="logo-home-link" className="flex items-center gap-3 group">
    <LogoMark className="h-9 w-9 transition-transform duration-300 group-hover:rotate-6" />
    <span className="leading-none">
      <span className={`block font-display font-extrabold text-lg tracking-tight ${dark ? "text-white" : "text-ink"}`}>
        Tranzlytics
      </span>
      <span className={`block font-mono text-[10px] uppercase tracking-[0.22em] mt-1 ${dark ? "text-white/50" : "text-gray-500"}`}>
        Services &amp; Technology
      </span>
    </span>
  </Link>
);
